import cn from 'classnames'
import AttachmentFileIcon from 'ext-ui/svg/icon/AttachmentFileIcon'
import React, { ComponentProps, ReactElement } from 'react'
import TrashButton from 'src/components/TrashButton/TrashButton'
import { useTranslate } from 'src/localization/Trns'

import style from './FileDisplay.style'

type FileDisplayProps = {
  className?: string
  fileName: string
  urls: {
    original: string
    thumb: string
  }
  removeFile?: () => void
  // If non interactable, this prop is safe to remove
  'data-testid': string
} & ComponentProps<'div'>

// Future Improvements: Display file size
// Not initially implemented since we dont save file sizes in the BE
// function humanFileSize(size: number) {
//   var i = size == 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024))
//   return (
//     +(size / Math.pow(1024, i)).toFixed(2) * 1 +
//     ' ' +
//     ['B', 'kB', 'MB', 'GB', 'TB'][i]
//   )
// }

function FileDisplay(props: FileDisplayProps): ReactElement {
  const { className = '', fileName, urls, removeFile, ...rest } = props
  const translate = useTranslate()

  const renderThumbnail = () => {
    // Check if the file is a PDF based on filename or thumbnail URL
    const isPDF =
      fileName.toLowerCase().endsWith('.pdf') ||
      urls.thumb.toLowerCase().includes('.pdf') ||
      urls.original.toLowerCase().endsWith('.pdf')

    if (isPDF) {
      // For PDFs, show a PDF icon
      return (
        <div className={'thumbnail pdf'}>
          <AttachmentFileIcon width={36} height={36} />
        </div>
      )
    }

    // For other file types, show the thumbnail image
    return (
      <img
        className={'thumbnail'}
        src={urls.thumb}
        alt={translate('thumbnail')}
      />
    )
  }

  return (
    <div className={cn('FileDisplay', className)} css={style} {...rest}>
      <div className={'flex-row gap-4 align-center'}>
        <a
          href={urls.original}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={'openFile'}
        >
          {renderThumbnail()}
        </a>
        <div className={'flex-column gap-1'}>
          <div className={'font-regular'}>{fileName}</div>
          {/* Future Improvements: display file size
          <div className={'font-form-label'}>{humanFileSize(file.size)}</div> */}
        </div>
      </div>
      {removeFile && <TrashButton onClick={removeFile} />}
    </div>
  )
}

export default FileDisplay
